import React, { useRef } from "react";
import styles from "./styles.module.scss";
import type { StoreListItem } from "@/types/filters";
import IconWithTooltip from "../IconWithTooltip";
import Link from "next/link";
import { formatZipcode } from "@/utils/helpers";
import { formatDistanceToKm } from "@/utils/geoLocation";

interface NearbyStoreItemProps {
  item: StoreListItem;
  index: number;
  distance: number;
}

export const NearbyStoreItem = ({
  item,
  index,
  distance
}: NearbyStoreItemProps) => {
  const containerRef = useRef<HTMLUListElement>(null);

  if (!item?.address?.street) {
    return <></>;
  }

  const calculateAlignment = (index: number) => {
    return index < 3 ? "left" : "center";
  };

  const kilometer = formatDistanceToKm(distance);

  return (
    <div className={`${styles["listCard-item"]}`} key={index}>
      <Link
        href={`/lojas/${item.slug}`}
        aria-label={`Detalhes da loja ${item.name}`}
        role="link"
      >
        <div className={`${styles["listCard-item-content"]}`}>
          <div className={styles.title} title={item.name}>
            {item.name}
          </div>
          <div className={`${styles["item-address"]} body-text-sm`}>
            <span>
              {item.address.street}, {item.address.number || "S/N"}
            </span>
            {item.address.city}-{item.address.state}
            <br />
            {formatZipcode(item.address.zipcode) || ""}
          </div>
        </div>
      </Link>
      <div className={`${styles["listCard-item-content"]} ${styles.grid}`}>
        <ul id="container-list" className={styles.facility} ref={containerRef}>
          {item.facilidades.slice(0, 5).map((facility, index) => (
            <IconWithTooltip
              key={index}
              icon={facility.icon}
              description={facility.name}
              tooltipAlignment={calculateAlignment(index)}
            />
          ))}
        </ul>
        <div className={styles.title} title={item.name}>
          {`${kilometer}`}
        </div>
      </div>
    </div>
  );
};
